// Barrel file for webapp utils. Currently re-exports the small set of helpers
// referenced by ported admin components. Extend as additional helpers are
// pulled across.
export const getFileExt = (name) => {
  if (typeof name === "string" && name.indexOf(".") >= 0) {
    return name.split(".").pop();
  }
  return "";
};

export const getFileName = (name) => {
  if (typeof name !== "string") return "";
  if (name.includes(".")) return name.substring(0, name.lastIndexOf("."));
  return name;
};
